import ListView from '@ingka/list-view';

import { usePriceSummaryOverviewContentsEntries } from './price-summary-overview-contents-list.hooks';
import { PriceSummaryOverviewEntry } from './price-summary-overview-entry.component';

import styles from '../../styles.module.scss';

export const PriceSummaryOverviewContentsList = () => {
    const entries = usePriceSummaryOverviewContentsEntries();

    return (
        <ListView
            className={styles.asset_price_summary_list ?? ''}
            id="price-contents"
            size="small"
            showDivider={false}
        >
            {entries.map((entry) => (
                <PriceSummaryOverviewEntry {...entry} key={entry.id} />
            ))}
        </ListView>
    );
};
